module.exports = __webpack_public_path__ + "static/media/restaurants.ea5db561.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/restaurants.jpg
// module id = 437
// module chunks = 0